import React from 'react';

function CategoryTag({ label, active = false, onClick }) {
  const baseClass = 'px-3 py-1 rounded-full font-sans text-caption font-semibold transition-colors duration-fast';

  const colorClass = active
    ? 'bg-primary-100 text-primary-700'
    : 'bg-sand-100 text-neutral-600';

  const hoverClass = onClick
    ? active
      ? 'hover:bg-primary-200 cursor-pointer'
      : 'hover:bg-sand-200 cursor-pointer'
    : '';

  const focusClass = onClick ? 'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1' : '';

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${baseClass} ${colorClass} ${hoverClass} ${focusClass}`}
      >
        {label}
      </button>
    );
  }

  return (
    <span className={`${baseClass} ${colorClass}`}>
      {label}
    </span>
  );
}

export default CategoryTag;
